import React from 'react';

import { IUserMentionMessage } from './types';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';

interface UserMentionMessageProps {
    message: IUserMentionMessage;
    className: string;
}

export function UserMentionMessage({
	message,
	className,
}: UserMentionMessageProps): JSX.Element {
	return (
		<LocalizedLink
			className={className}
			target="_blank"
			to={`/profile/${message.userId}`}
		>
			{message.text}
		</LocalizedLink>
	);
}
